export enum RodoClauseEndpoint {
  GetClause = '/api/system/owner/klauzularodo',
}
